import { Link } from 'react-router-dom';
import { currentBrand } from '../lib/brand.js';

/** Developer reference. Linked from the AgentMeetings nav. */
export function DocsPage(): JSX.Element {
  const brand = currentBrand();
  const origin = window.location.origin;
  const mcp = JSON.stringify(
    {
      mcpServers: {
        [brand.mcpServerKey]: {
          url: `${origin}/mcp`,
          headers: { Authorization: 'Bearer tnk_YOUR_KEY' },
        },
      },
    },
    null,
    2,
  );

  return (
    <div>
      <h1 className="page-title">Docs</h1>
      <p className="page-subtitle">
        Connect agents to {brand.name} with API keys, MCP, and webhooks.
      </p>
      <div className="account-grid">
        <section className="panel">
          <h2 className="panel__title">API</h2>
          <p className="form-help" style={{ marginTop: 0 }}>
            Send <code>Authorization: Bearer tnk_…</code> to <code>{origin}/api/v1</code>.
            Create a key on <Link to="/settings/developers#api-keys">API keys</Link>. The raw key is shown once.
            The shared script token still works for server jobs.
          </p>
        </section>
        <section className="panel">
          <h2 className="panel__title">MCP</h2>
          <p className="form-help" style={{ marginTop: 0 }}>
            Claude Desktop, Cursor, and other MCP hosts call <code>{origin}/mcp</code> with a bearer key.
            Use <code>read:meetings</code> and <code>read:actions</code>. Add <code>push</code> only when that
            agent should push actions. Search does not return the full transcript.
          </p>
          <pre className="mcp-config">{mcp}</pre>
          <p className="form-help">
            Hosts that only launch a local command can use{' '}
            <code>npx -y mcp-remote {origin}/mcp --header "Authorization: Bearer tnk_YOUR_KEY"</code>.
          </p>
        </section>
        <section className="panel">
          <h2 className="panel__title">Webhooks</h2>
          <p className="form-help" style={{ marginTop: 0 }}>
            {brand.name} POSTs <code>meeting.completed</code>, <code>meeting.failed</code>, and the action
            events you select on <Link to="/settings/developers#webhooks">Webhooks</Link>. Each request
            includes <code>{brand.signatureHeader}: sha256=…</code>, an HMAC of the raw body. The signing
            secret is shown once when you register an endpoint.
          </p>
        </section>
      </div>
    </div>
  );
}
